import { create } from 'zustand';
import { AppNotification } from '../../components/NotificationSystem';

interface UIState {
  isMenuOpen: boolean;
  setIsMenuOpen: (open: boolean) => void;
  isPanelMinimized: boolean;
  setIsPanelMinimized: (minimized: boolean) => void;
  isChatOpen: boolean;
  setIsChatOpen: (open: boolean) => void;
  isCameraOpen: boolean;
  setIsCameraOpen: (open: boolean) => void;
  isBulkImportOpen: boolean;
  setIsBulkImportOpen: (open: boolean) => void;
  scanMode: 'tag' | 'receipt' | 'import';
  setScanMode: (mode: 'tag' | 'receipt' | 'import') => void;
  showAddModal: boolean;
  setShowAddModal: (show: boolean) => void;
  showStoreModal: boolean;
  setShowStoreModal: (show: boolean) => void;
  storePickerMode: 'list' | 'map' | 'manual';
  setStorePickerMode: (mode: 'list' | 'map' | 'manual') => void;
  showDatePicker: boolean;
  setShowDatePicker: (show: boolean) => void;
  previewImageUrl: string | null;
  previewReceiptZoom: number | null;
  setPreviewImageUrl: (url: string | null, options?: { receiptZoom: number }) => void;
  notification: AppNotification | null;
  setNotification: (notif: AppNotification | null) => void;
  showAuthModal: boolean;
  setShowAuthModal: (show: boolean) => void;
  showClearConfirm: boolean;
  setShowClearConfirm: (show: boolean) => void;
  isInsightModalOpen: boolean;
  setIsInsightModalOpen: (show: boolean) => void;
  processingCount: number;
  setProcessingCount: (count: number | ((prev: number) => number)) => void;
}

export const useUIStore = create<UIState>((set) => ({
  isMenuOpen: false,
  setIsMenuOpen: (isMenuOpen) => set({ isMenuOpen }),
  isPanelMinimized: false,
  setIsPanelMinimized: (isPanelMinimized) => set({ isPanelMinimized }),
  isChatOpen: false,
  setIsChatOpen: (isChatOpen) => set({ isChatOpen }),
  isCameraOpen: false,
  setIsCameraOpen: (isCameraOpen) => set({ isCameraOpen }),
  isBulkImportOpen: false,
  setIsBulkImportOpen: (isBulkImportOpen) => set({ isBulkImportOpen }),
  scanMode: 'tag',
  setScanMode: (scanMode) => set({ scanMode }),
  showAddModal: false,
  setShowAddModal: (showAddModal) => set({ showAddModal }),
  showStoreModal: false,
  setShowStoreModal: (showStoreModal) => set({ showStoreModal }),
  storePickerMode: 'list',
  setStorePickerMode: (storePickerMode) => set({ storePickerMode }),
  showDatePicker: false,
  setShowDatePicker: (showDatePicker) => set({ showDatePicker }),
  previewImageUrl: null,
  previewReceiptZoom: null,
  setPreviewImageUrl: (previewImageUrl, options) => set({ previewImageUrl, previewReceiptZoom: previewImageUrl && options ? options.receiptZoom : null }),
  notification: null,
  setNotification: (notification) => set({ notification }),
  showAuthModal: false,
  setShowAuthModal: (showAuthModal) => set({ showAuthModal }),
  showClearConfirm: false,
  setShowClearConfirm: (showClearConfirm) => set({ showClearConfirm }),
  isInsightModalOpen: false,
  setIsInsightModalOpen: (isInsightModalOpen) => set({ isInsightModalOpen }),
  processingCount: 0,
  setProcessingCount: (processingCountOrFn) => set((state) => ({
    processingCount: typeof processingCountOrFn === 'function' ? processingCountOrFn(state.processingCount) : processingCountOrFn
  })),
}));
